import { Inject, Injectable, InjectionToken } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import type { IRetrievePipelineStepCompatibilityQuery } from '@protocols/use-cases';

import { PipelineStepDetailState } from '../state/pipeline-step-detail.state';

export const RETRIEVE_PIPELINE_STEP_COMPATIBILITY_QUERY = new InjectionToken<IRetrievePipelineStepCompatibilityQuery>(
  'RETRIEVE_PIPELINE_STEP_COMPATIBILITY_QUERY'
);

@Injectable()
export class PipelineStepDetailEffects {
  constructor(
    private readonly state: PipelineStepDetailState,
    @Inject(RETRIEVE_PIPELINE_STEP_COMPATIBILITY_QUERY)
    private readonly retrievePipelineStepCompatibilityQuery: IRetrievePipelineStepCompatibilityQuery
  ) {}

  // ============================================================================
  // Re-exposed selectors
  // ============================================================================

  public readonly compatibilityInfo$ = this.state.compatibilityInfo$;
  public readonly error$ = this.state.error$;

  // ============================================================================
  // Re-exposed updaters
  // ============================================================================

  public readonly setStep = this.state.setStep;

  // ============================================================================
  // Effects
  // ============================================================================

  public readonly loadStep = this.state.effect((id$: Observable<string>) =>
    id$.pipe(
      switchMap((id) =>
        from(this.retrievePipelineStepCompatibilityQuery.execute(id)).pipe(
          tapResponse(
            (step) =>
              this.state.setStep({
                outputLabels: step.outputLabels,
                outputLabelNames: step.outputLabelNames,
                task: step.task,
              }),
            (error: Error) =>
              this.state.setError(
                error.message || 'table.algorithms.switch_algorithm_dialog.errors.load_step_compatibility'
              )
          )
        )
      )
    )
  );
}
